import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class EventListService {

  constructor(private http: HttpClient) { }

  async getAllList(search, start, length, order, query, filter) {
    try {
      let response = await this.http
        // .get(`${appApiResources.getDonationList}?search=${search.search}&search_column=${search.search_column}&order_direct=${order.order_direct}&order_column=${order.order_column}&start=${start}&length=${length}&offering_type_id=${query.offerType}&bank_id=${query.bank}&from_date=${query.fromDate}&end_date=${query.toDate}&mode_id=${query.mode}&amt_greater=${query.amtGreater}&amt_lesser=${query.amtLesser}&event_id=${query.receiptEvent}&event_offering_type_id=${query.offeringTypeEventBased}`)
        // .get(`http://office.ezekiahfrancis.in/onlineoffreqs?search=${search.search}&search_column=${search.search_column}&order_direct=${order.order_direct}&order_column=${order.order_column}&start=${start}&length=${length}&offering_type_id=${query.offerType}&bank_id=${query.bank}&from_date=${query.fromDate}&end_date=${query.toDate}&mode_id=${query.mode}&amt_greater=${query.amtGreater}&amt_lesser=${query.amtLesser}&event_id=${query.receiptEvent}&event_offering_type_id=${query.offeringTypeEventBased}&status=${query.status}`)
        // .get("http://office.ezekiahfrancis.in/printlabels?event_id=0&role_id=1&language_id=0")
        .get(`http://office.ezekiahfrancis.in/eventsreglist?search=${search.search}&search_column=${search.search_column}&order_direct=${order.order_direct}&order_column=${order.order_column}&start=${start}&length=${length}&${filter}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  async removeEvent(data) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      };
      let response = await this.http
        .post(`http://office.ezekiahfrancis.in/deleteeventreg`, data, httpOptions)
        .toPromise();
      return response;

    } catch (error) {
      return error;
    }
  }

}